import SortableView from "backbone/shared/views/sortable_view.js"

$selectors =
  step: ".js-step"
  totalPrice: ".js-total-price"
  workerPrice: ".js-worker-price"
  payment: ".js-add-payment"
  eligibleField: ".js-step-eligible-to"
  remoteToggle: ".js-off-platform-toggle"
  standardToggle: ".js-standard-step-toggle"
  typeToggles: ".js-step-type"
  remoteApproverRow: ".js-remote-approver-row"

export default class ApprovalFlowFormView extends SortableView
  events:
    "nested:fieldAdded:story_approval_steps"        : "onStepAdded"
    "nested:fieldRemoved:story_approval_steps"      : "onStepRemoved"
    "nested:fieldAdded:steps"                       : "onStepAdded"
    "nested:fieldRemoved:steps"                     : "onStepRemoved"
    "nested:fieldAdded:remote_approval_templates"   : "onRemoteApproverAdded"
    "nested:fieldRemoved:remote_approval_templates" : "onRemoteApproverRemoved"
    "click .js-off-platform-toggle"                 : "onStepTypeChange"
    "click .js-standard-step-toggle"                : "onStepTypeChange"
    "sortstop"                                      : "onSortStop"

  initialize: ->
    super
    _.extend(@events, SortableView.prototype.events)
    @$form = @$el
    contently.ui.setup_select2(@$form)
    @setupStepValidationsAndDisplay()

  setupStepValidationsAndDisplay: ->
    for stepWithTypes in $($selectors.typeToggles)
      @setupStepTypeDisplay($(stepWithTypes).parents($selectors.step))

  setupRemoteStepDisplay: ($step) ->
    $remoteApprover = $step.find($selectors.remoteApproverRow)
    $remoteApprover.find(".js-destroy-remote-approval").find("input").val("0")
    $remoteApproversSelect = $remoteApprover.find("select")
    $remoteApprover.show()

  removeRemoteStepDisplay: ($step) ->
    $remoteApprover = $step.find($selectors.remoteApproverRow)
    $remoteApprover.hide()
    $remoteApproversSelect = $remoteApprover.find("select")
    $remoteApproversSelect.val("")
    $remoteApprover.find(".js-destroy-remote-approval").find("input").val("1")

  _eligibleToType: ($eligibleToSelect) ->
    @_eligibleToValues($eligibleToSelect)[0]

  _eligibleToId: ($eligibleToSelect) ->
    @_eligibleToValues($eligibleToSelect)[1]

  _eligibleToValues: ($eligibleToSelect) ->
    $eligibleToSelect.val().split("::")

  _eligibleToTeam: ($eligibleToSelect) ->
    @_eligibleToType($eligibleToSelect) == "Team"

  _eligibleToUser: ($eligibleToSelect) ->
    @_eligibleToType($eligibleToSelect) == "User"

  onStepAdded: (event) ->
    $step = event.field
    contently.ui.setup_select2($step)
    @setupStepTypeDisplay($step)
    @_handleParsleyFields(event, "addItem")

  onStepRemoved: (event) ->
    @_handleParsleyFields(event, "removeItem")

  onStepTypeChange: (e) ->
    $toggle = $(e.target)
    return if $toggle.hasClass("disabled")
    $step = $toggle.parents($selectors.step)
    $step.find($selectors.typeToggles).removeClass("active")
    $toggle.closest(".button").addClass("active")
    @setupStepTypeDisplay($step)

  setupStepTypeDisplay: ($step) ->
    if $step.find($selectors.remoteToggle).hasClass("active")
      @setupRemoteStepDisplay($step)
    else if $step.find($selectors.standardToggle).hasClass("active")
      @removeRemoteStepDisplay($step)

  onRemoteApproverAdded: (event) ->
    $remoteApprover = event.field
    contently.ui.setup_select2($remoteApprover)

  onRemoteApproverRemoved: (event) ->
    $remoteApprover = event.field
    $remoteApproversSelect = $remoteApprover.find("select")
    $remoteApproversSelect.removeAttr("required")
    $remoteApprover.detach().appendTo(@$form)

  onSortStop: (e, ui) ->
    super
    @_setFirstStepToStandard()

  _setFirstStepToStandard: ->
    if $($selectors.typeToggles).length > 0
      $($selectors.step).first().find($selectors.standardToggle).click()

  _handleParsleyFields: (event, action) ->
    $step = event.field
    $title = $step.find(".js-step-title")
    $eligibleSelect = $step.find($selectors.eligibleField)
    $totalPrice = $step.find(".js-total-price")
    $workerPrice = $step.find(".js-worker-price")
    $remoteApprover = $step.find(".js-remote-approver-row").find("select")

    for input in [$title, $eligibleSelect, $totalPrice, $workerPrice, $remoteApprover]
      continue if input.length == 0

    switch action
      when "addItem"
        $title.prop("required", true)
        $eligibleSelect.select2
          minimumResultsForSearch: 10
      when "removeItem"
        $step.detach().appendTo(@$form)
        $title.removeAttr("required")
        $remoteApprover.removeAttr("required")



// WEBPACK FOOTER //
// ./app/javascript/backbone/platform/views/approval_flow_form_view.js.coffee